import { styled } from "@mui/material";

export const FullViewContainer = styled("div")(({ theme }) => ({
  display: "flex",
  position: "fixed",
  top: "0px",
  left: 0,
  zIndex: 99999999,
  minWidth: "100vw",
  height: "100dvh",
  padding: "0px",
  backgroundColor: theme.palette.surface.silver,
}));

export const OnboardingCard = styled("div")(({ theme }) => ({
  background: `url("/onboarding-bg.png") repeat-x`,
  backgroundSize: "fixed",
  backgroundPosition: "bottom",
  backgroundColor: theme.palette.surface.bg,
}));

export const OnboardingCardV2 = styled("div")(({ theme }) => ({
  backgroundColor: "#000000",
}));

export const OnboardingImage = styled("img")(({ theme }) => ({
  width: "80%",
  maxWidth: "400px",
  aspectRatio: "1/1",
}));
